import { useContext, useEffect, useState, useRef } from 'react';
import { BrowserRouter, Switch, Route, useLocation } from 'react-router-dom';
import LeavePageDialog from './components/common/LeavePageDialog';
import { ROUTER_CONFIRM_EVENT, resolveConfirm } from './utils/routerConfirm';
import './App.css';
import Main from './components/Main';
import { AdminDashboard } from './components/admin/AdminDashboard';
import ProfileList from './components/Profile/ProfileList';
import { Dashboard } from './components/Dashboard';
import UserList from './components/CMEUser/CMEUserList';
import UnclaimedCMEDashboard from './components/UnclaimedCMEDashboard/UnclaimedCMEDashboard';
import MostRecentActivitiesDashboard from './components/MostRecentActivitiesDashboard/MostRecentActivitiesDashboard';
import InProgress from './components/InProgress/InProgress';
import SelfReportActivity from './components/SelfReportedActivity';
import SelfReportSubmit from './components/SelfReportedSubmit';
import ScrollToTopButton from './components/common/ScrollToTopButton';
import DeletedActivities from './components/DeletedActivities';
import MergeCME from './components/MergeCME';
import ManageRequirements from './components/CMERequirementManagement/ManageRequirements';
import AcepMaster from './acep-master';
import { FEATURE_CME_Req } from './config/config';
import { Redirect } from 'react-router-dom';
import { userContext } from "./context/userContext";
 

function App() {
  const [isAcepMasterLoaded, setAcepMasterLoaded] = useState(false);
  const [routerDialogOpen, setRouterDialogOpen] = useState(false);

  const handleAcepMasterLoad = () => {
    setAcepMasterLoaded(true);
  };

  useEffect(() => {
    const handler = () => setRouterDialogOpen(true);
    window.addEventListener(ROUTER_CONFIRM_EVENT, handler);
    return () => window.removeEventListener(ROUTER_CONFIRM_EVENT, handler);
  }, []);
 
  
  return (
    <>
    <AcepMaster onAcepMasterLoad={handleAcepMasterLoad}>
        {isAcepMasterLoaded ? (
          <div className="App">
            <ScrollToTopButton />
            {/* <Main />     */}

            <Switch>
              <Route path="/index.html" exact component={Dashboard} />
              <Route path="/index.htm" exact component={Dashboard} />
              <Route path="/" exact component={Dashboard} />
              <Route path="/dashboard" exact component={Dashboard} />
              <Route path="/dashboard/Admin" exact component={AdminDashboard} />
              <Route path="/dashboard/CMEProfiles" exact component={ProfileList} />
              <Route path="/dashboard/CMEUsers" exact component={UserList} />
              <Route path="/dashboard/UnclaimedCME" exact component={UnclaimedCMEDashboard} />
              <Route path="/dashboard/InProgress" exact component={InProgress} />
              <Route path="/dashboard/MostRecentActivities" exact component={MostRecentActivitiesDashboard} />
              <Route path="/dashboard/SelfReported" exact component={SelfReportActivity} />
              <Route path="/dashboard/SelfReportedSubmit" exact component={SelfReportSubmit} />
              <Route path="/dashboard/DeletedActivities" exact component={DeletedActivities} />
              <Route path="/dashboard/MergeCME" exact component={MergeCME} />
              <Route path="/dashboard/ManageRequirements" exact render={() => FEATURE_CME_Req ? <ManageRequirements /> : <Redirect to="/" />} />
            </Switch>

          </div>
        ):  null
          }
    </AcepMaster>
    <LeavePageDialog
      open={routerDialogOpen}
      onLeave={() => { setRouterDialogOpen(false); resolveConfirm(true); }}
      onStay={() => { setRouterDialogOpen(false); resolveConfirm(false); }}
    />
    </>
  );
}

export default App;

